// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function toString(x) {
  switch (x) {
    case "CONDO" :
      return "CONDO";
    case "LOT" :
      return "LOT";
    case "MULTI_UNIT" :
      return "MULTI_UNIT";
    case "SINGLE_FAMILY" :
      return "SINGLE_FAMILY";
  }
}

function toDisplayString(x) {
  switch (x) {
    case "CONDO" :
      return "Condo/Townhouse";
    case "LOT" :
      return "Lot";
    case "MULTI_UNIT" :
      return "Multi unit";
    case "SINGLE_FAMILY" :
      return "Single-family";
  }
}

let PropertyType = {
  toString: toString,
  toDisplayString: toDisplayString
};

function toString$1(x) {
  if (x === "CONDO") {
    return "CONDO";
  } else {
    return "SINGLE_FAMILY";
  }
}

function toDisplayString$1(x) {
  if (x === "CONDO") {
    return "Condo/Townhouse";
  } else {
    return "Single-family";
  }
}

let RentalPropertyType = {
  toString: toString$1,
  toDisplayString: toDisplayString$1
};

let Price = {};

let Visibility = {};

function toString$2(x) {
  switch (x) {
    case "LONG" :
      return "LONG";
    case "SHORT" :
      return "SHORT";
    case "SHORT_OR_LONG" :
      return "SHORT_OR_LONG";
  }
}

function toDisplayString$2(x) {
  switch (x) {
    case "LONG" :
      return "Long";
    case "SHORT" :
      return "Short";
    case "SHORT_OR_LONG" :
      return "Both Short and Long";
  }
}

let LeaseLength = {
  toString: toString$2,
  toDisplayString: toDisplayString$2
};

let Time;

let Attachment;

exports.PropertyType = PropertyType;
exports.RentalPropertyType = RentalPropertyType;
exports.Price = Price;
exports.Visibility = Visibility;
exports.LeaseLength = LeaseLength;
exports.Time = Time;
exports.Attachment = Attachment;
/* No side effect */
